import React, {Component} from 'react';
import {toast} from 'react-toastify';
import {withTranslation} from 'react-i18next';
import {APIClient} from "../../../utils/APIClient";
import {URLQueryStringParser} from "../../../utils/URLQueryStringParser";
import {API_URL} from '../../../settings/local_settings';
import {Loading} from "../../Loading";
import { LINKEDIN_CHANNEL } from '../../channels/channels';


import {withRouterParams} from "../../../utils/withRouterParams";
import {clearOauthReturn, destinationOf, errorDestinationOf, peekOauthReturn} from '../../onboarding/oauthReturn';
import {consumePendingLinkedinConnection} from '../connections/pendingLinkedinReconnect';
import {forgetReconnect} from '../connections/reconnectNote';
import {
    announceReconnectNotice, ORIGIN_ACCOUNT, ORIGIN_CREDENTIAL, ORIGIN_NEW, reconnectNotice, reconnectResultOf,
    recordReconnectResult,
} from '../connections/reconnectAccountText';

class ConnectLinkedin extends Component {
    constructor(props) {
        super(props);
        this.componentDidMount = this.componentDidMount.bind(this);
    }

    componentDidMount() {
        // La nota se lee UNA vez, al montar, y el destino viaja capturado: leerla al final
        // —dentro del `.then()` del POST— la encontraba borrada cuando el marco del túnel ya se
        // había montado, y devolvía al usuario a la pantalla clásica encima del recorrido. Ver
        // `destinationOf` en `oauthReturn`.
        const tunnelReturn = peekOauthReturn();
        const inTunnel = Boolean(tunnelReturn);

        // Navegar y CONSUMIR la nota: es de un solo uso y acá el recorrido termina. Si sobrevive,
        // el «atrás» del navegador vuelve sin `code` y pinta la tarjeta como fallida sobre una
        // conexión que anduvo, y hasta quince minutos después secuestra al túnel la próxima
        // conexión hecha desde la pantalla clásica. Ver `ConnectAdwordsAccount`.
        const irA = destino => {
            this.props.history.push(destino);
            clearOauthReturn();
        };
        let code = new URLQueryStringParser().getUrlParams('code');
        let auth_code = new URLQueryStringParser().getUrlParams('auth_code');
        // Nombre, conexión a reconectar y cuenta a re-asignar salen SÓLO de la nota de sessionStorage
        // (15 min, un uso), que toda entrada al OAuth de LinkedIn escribe entera. Lo que haya quedado
        // en localStorage de otro flujo se descarta: un nombre viejo ahí hacía que el backend, que
        // matchea por nombre, le escribiera el token nuevo a una conexión ajena (QA-linkedin-07).
        localStorage.removeItem('pending_credential_label');
        forgetReconnect();
        const pending = consumePendingLinkedinConnection() || {};
        let origin = ORIGIN_NEW;
        if (pending.adAccountId) origin = ORIGIN_ACCOUNT;
        else if (pending.id) origin = ORIGIN_CREDENTIAL;
        let postData = {'code': code, 'auth_code': auth_code, 'credential_label': pending.label || null};
        if (pending.adAccountId) {
            postData['reconnect_ad_account_id'] = pending.adAccountId;
        }
        if (pending.id) {
            postData['reconnect_credential_id'] = pending.id;
        }
        const failed = () => {
            // Mensaje propio, nunca el del backend (puede nombrar otra agencia), y con salida: sin
            // rama de fallo, un corte de red dejaba «Por favor espere…» para siempre.
            if (!inTunnel) toast.error(this.props.t('linkedin_link.error.generic'));
            irA(errorDestinationOf(tunnelReturn, '/agency/conections?just_connected=' + LINKEDIN_CHANNEL,
                                                       LINKEDIN_CHANNEL));
        };

        new APIClient(API_URL + 'get_access_tokens/linkedin/').call('POST', postData).then((data) => {
            if (data && data.status === 'OK') {
                const result = reconnectResultOf(data);
                recordReconnectResult(LINKEDIN_CHANNEL, result, origin);
                irA(destinationOf(tunnelReturn, '/agency/conections?just_connected='+LINKEDIN_CHANNEL));
                if (!inTunnel) {
                    const notice = reconnectNotice(this.props.t, LINKEDIN_CHANNEL, result, origin);
                    if (notice) announceReconnectNotice(notice);
                    else toast.success(this.props.t('linkedin_link.connected'));
                }
                return;
            }
            failed();
        }).catch(failed);
    }

    render() {
        return <Loading message={this.props.t('connections.oauth.connecting')}/>
    }
}

export default withTranslation()(withRouterParams(ConnectLinkedin));
